import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[noEmptySpacesOnly]',
})
export class NoEmptySpacesOnlyDirective {
  constructor(
    private el :ElementRef,
    @Optional() private ngControl :NgControl,
  ) {}

  @HostListener('input')
  onInput() {
    const value = this.el.nativeElement.value.trim();
    if (value === '' || /^\s+$/.test(value)) {
      if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.setErrors({ noEmptySpacesOnly: true });
        this.ngControl.control.invalid;
      }
    } else {
      if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.setErrors(null);
      }
    }
  }
}
